import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import me from "../../../Assests/me.jpg";
import LiquidEther from 'LiquidEther';

const HeroSection = () => {
  return (
    <section className="w-full min-h-screen relative bg-gradient-to-br from-deep-space via-slate-900 to-slate-800 overflow-hidden flex items-center">
      {/* Liquid Background */}
      <div className="absolute inset-0 pointer-events-none">
        <LiquidEther
          colors={['#5227FF', '#FF9FFC', '#B19EEF']}
          mouseForce={20}
          cursorSize={100}
          isViscous={false}
          viscous={30}
          iterationsViscous={32}
          iterationsPoisson={32}
          resolution={0.5}
          isBounce={false}
          autoDemo={true}
          autoSpeed={0.5}
          autoIntensity={2.2}
          takeoverDuration={0.25}
          autoResumeDelay={3000}
          autoRampDuration={0.6}
        />
      </div>

      {/* Main Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Section */}
          <div className="space-y-8 text-center lg:text-left">
            <div className="space-y-4">
              <div className="flex justify-center lg:justify-start items-center space-x-2">
                <Icon name="Rocket" size={24} className="text-rocket-fire" />
                <span className="text-electric-cyan font-medium">Mission Brief</span>
              </div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-headline text-white leading-tight">
                From Student to{" "}
                <span className="text-transparent bg-gradient-to-r from-rocket-fire to-electric-cyan bg-clip-text">
                  Professional
                </span>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-slate-300 leading-relaxed">
                Bridging academic excellence with real-world impact through
                innovative problem-solving and continuous learning.
              </p>
            </div>

            {/* Mission / Core Values */}
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-rocket-fire/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Target" size={20} className="text-rocket-fire" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">Mission Objective</h3>
                  <p className="text-slate-300 text-sm sm:text-base">
                    To apply my expertise in the MERN stack and problem-solving
                    to build innovative and scalable web solutions...
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-electric-cyan/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Zap" size={20} className="text-electric-cyan" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">Core Values</h3>
                  <p className="text-slate-300 text-sm sm:text-base">
                    My values are rooted in engineering excellence, collaborative
                    problem-solving, and adaptability...
                  </p>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://drive.google.com/file/d/1Z6dDJOKy3zWfDfeohi6FU9feCnjSGTFM/view?usp=sharing">
                <Button
                  variant="default"
                  className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta w-full sm:w-auto"
                  iconName="Download"
                  iconPosition="left"
                >
                  Download Resume
                </Button>
              </a>
              <a href="https://drive.google.com/file/d/1ydEi_yoknlclXfqCbqUazW4I42CvPdev/view?usp=drive_link">
                <Button
                  variant="outline"
                  className="border-electric-cyan text-electric-cyan hover:bg-electric-cyan hover:text-deep-space w-full sm:w-auto"
                  iconName="ExternalLink"
                  iconPosition="right"
                >
                  View Certifications
                </Button>
              </a>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#TransformAndTimeline">
                <Button
                  variant="default"
                  className="bg-blue-500 hover:bg-blue-700 text-white rounded-full w-full sm:w-auto"
                  iconName="BarChart"
                  iconPosition="left"
                >
                  Transformation Timeline
                </Button>
              </a>
              <a href="#CoreValues">
                <Button
                  variant="default"
                  className="bg-blue-500 hover:bg-blue-700 text-white rounded-full w-full sm:w-auto"
                  iconName="Server"
                >
                  Core Values
                </Button>
              </a>
              <a href="#academics">
                <Button
                  variant="default"
                  className="bg-blue-500 hover:bg-blue-700 text-white rounded-full w-full sm:w-auto"
                  iconName="Brain"
                  iconPosition="left"
                >
                  Academics Background
                </Button>
              </a>
            </div>
          </div>

          {/* Image Section with Floating Stats */}
          <div className="relative flex justify-center lg:justify-end">
            {/* Image */}
            <div className="relative z-10">
              <div className="w-64 sm:w-80 md:w-96 mx-auto">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-rocket-fire to-electric-cyan rounded-2xl blur opacity-30"></div>
                  <div className="relative bg-slate-800 rounded-2xl shadow-2xl">
                    <Image
                      src={me}
                      alt="Professional headshot"
                      className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-xl"
                    />
                    <div className="absolute -bottom-4 -right-4 w-12 sm:w-16 h-12 sm:h-16 bg-trust-green rounded-full flex items-center justify-center shadow-lg">
                      <Icon name="CheckCircle" size={20} className="text-white sm:size-24" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Stats */}
            <div className="absolute -top-6 -left-16 sm:-top-10 sm:-left-20 bg-slate-800/90 backdrop-blur-sm rounded-lg p-3 sm:p-4 shadow-xl border border-slate-700">
              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-rocket-fire">8.09</div>
                <div className="text-xs text-slate-400">GPA</div>
              </div>
            </div>

            <div className="absolute -bottom-6 -right-16 sm:-bottom-10 sm:-right-20 bg-slate-800/90 backdrop-blur-sm rounded-lg p-3 sm:p-4 shadow-xl border border-slate-700">
              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-electric-cyan">15+</div>
                <div className="text-xs text-slate-400">Projects</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
